import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import Text from '../../01-atoms/Text/Text';
import unwidow from '../../../utilities/unwidow';

import './BlogPostTeaser.css';

const BlogPostTeaser = ({
  description,
  image,
  imageLoading,
  semanticLevel = 2,
  title,
  to,
}) => {
  const bodyProps = {};

  let BodyTag = `div`;

  if (to) {
    BodyTag = Link;
    bodyProps.to = to;
  }

  return (
    <article className="BlogPostTeaser">
      <BodyTag {...bodyProps} className="BlogPostTeaser__body">
        <div className="BlogPostTeaser__cover">
          <GatsbyImage
            alt={image.alt}
            image={image.src.childImageSharp.gatsbyImageData}
            loading={imageLoading}
          />
        </div>
        <div className="BlogPostTeaser__content">
          <Text className="BlogPostTeaser__title" semanticLevel={semanticLevel}>
            {title}
          </Text>
          <Text className="BlogPostTeaser__description">
            {unwidow(description)}
          </Text>
          {!!to && (
            <Text className="BlogPostTeaser__call-to-action">Read more</Text>
          )}
        </div>
      </BodyTag>
    </article>
  );
};

export default BlogPostTeaser;
